var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('five-header',{attrs:{"actIndex":_vm.actIndex,"imgList":_vm.imgList,"topStyle":_vm.topStyle,"logo":_vm.logo,"productType":_vm.productType,"titleObj":_vm.titleObj}}),_vm._v(" "),_c('five-center'),_vm._v(" "),_c('five-footer',{attrs:{"bottomNews":_vm.bottomNews,"bottom":_vm.bottom,"bottomInfo":_vm.bottomInfo,"productType":_vm.productType}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5807ecdf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pc/fiveG.vue
// module id = null
// module chunks = 